import { NavLink } from 'react-router-dom';

import useTranslation from 'customHooks/translate';

import { settingsLinks } from './settingsLinks';

const SettingsSidebar = () => {
  const translation = useTranslation();

  return (
    <div className="no-scrollbar flex flex-row gap-[4px] overflow-x-auto bg-white px-[16px] md:flex-col md:overflow-x-visible md:px-[32px] md:py-[23px]">
      {settingsLinks(translation)?.map((settingsLink) => (
        <NavLink
          key={settingsLink?.url}
          to={settingsLink?.url}
          className={({ isActive }) =>
            `max-w flex transform-none items-center p-[10px] text-center text-[14px] font-normal no-underline md:rounded-[10px] md:px-[14px] md:py-[12px] md:text-left md:text-[16px]
    ${
      isActive
        ? 'border-b-[2px] border-b-[#466AFB] md:bg-[#466AFB] md:text-white md:hover:text-white'
        : 'border-b-[2px] border-b-[transparent]'
    }`
          }
        >
          {settingsLink?.name}
        </NavLink>
      ))}
    </div>
  );
};

export default SettingsSidebar;
